export default "__VITE_ASSET__8b945479__"